/**
 * Admin audit logs API endpoints.
 */

import { http } from './http';
import type { AuditLog, AuditLogFilters, PaginatedResponse } from './types';

/** GET /api/v1/admin/audit-logs */
export async function listAuditLogs(
  filters?: AuditLogFilters,
): Promise<PaginatedResponse<AuditLog>> {
  const params = new URLSearchParams();
  if (filters?.action) params.set('action', filters.action);
  if (filters?.target_type) params.set('target_type', filters.target_type);
  if (filters?.admin_id) params.set('admin_id', filters.admin_id);
  if (filters?.cursor) params.set('cursor', filters.cursor);
  if (filters?.limit) params.set('limit', String(filters.limit));
  if (filters?.created_after) params.set('created_after', filters.created_after);
  if (filters?.created_before) params.set('created_before', filters.created_before);

  const query = params.toString();
  return http.get(`/admin/audit-logs${query ? `?${query}` : ''}`);
}
